export default __webpack_public_path__ + "static/media/dropdownWhite.2ca5ee62.svg";